// Globals
const tools = document.querySelector('.tools');


// =======================================================
// Search
// =======================================================

// Variables
const searchpage = document.querySelector('body.search');
const searchTool = tools.querySelector('#js-toolSearch');
const searchPopup = document.querySelector('.search-popup');
const searchInput = document.querySelector('#searchInput');
const searchClose = document.querySelector('.search-close');

if (!searchpage) {
    searchClose.setAttribute('tabindex', -1);
    searchInput.setAttribute('tabindex', -1);
}

// Event click
searchTool.addEventListener('click', function() {
    document.body.classList.add('search-open');
    searchPopup.classList.remove('hideX');
    searchPopup.classList.add('showX');
    document.querySelector('.searchInput').focus()
    searchClose.setAttribute('tabindex', 0);
    searchInput.setAttribute('tabindex', 0);
})

if (searchPopup) {
    if (searchClose) {
        searchClose.addEventListener('click', function () {
            document.body.classList.remove('search-open');
            searchPopup.classList.add('hideX');
            searchPopup.classList.remove('showX');
            this.setAttribute('tabindex', -1);
            searchInput.setAttribute('tabindex', -1);
        })
    }
}


// =======================================================
// Profils
// =======================================================
// Variable
const profileBtn = tools.querySelector('#js-toolProfile');

// Event click
if (profileBtn) {
    !!profileBtn && profileBtn.addEventListener('click', function() {
        profileBtn.closest('.header').querySelector('.tools-view .profils').classList.toggle('show-list');
    })
}

// // =======================================================
// // Google Translate
// // =======================================================
// window.addEventListener("load", (event) => {
//     console.log("page is fully loaded");

//     // Variable
//     const tools             = document.querySelector('.tools');
//     const translateBtn      = tools.querySelector('#js-translateBtn');
//     const translateClose    = tools.querySelector('#js-translateBtn--close');
//     const translateWrapper  = tools.querySelector('#js-translateWrapper');
//     const translatelinks    = tools.querySelectorAll('.tools__translate a.glink');
//     const translateGoogle   = tools.querySelector('#google_translate_element2');

//     if (translateBtn) {

//         // Move close button at the end
//         translateWrapper.insertBefore(translateClose, translateGoogle);

//         !!translateBtn && translateBtn.addEventListener('click', function() {
//             translateWrapper.classList.add('js-open');
//         })

//         translatelinks.forEach(function (translatelink) { 
            
//             translatelink.addEventListener('click', function() {
//                 this.parentElement.classList.remove('js-open');
//             })
//         });

//         translateClose.addEventListener('click', function() {
//             translateWrapper.classList.remove('js-open');
//         });

//         document.addEventListener("mouseup", function(event) {
//             if (!translateWrapper.contains(event.target)) {
//                 translateWrapper.classList.remove('js-open');
//             }
//         });
//     }

// });



// =======================================================
// Favorite
// =======================================================
// // Variable
// const favoriteBtn = tools.querySelector('#js-toolFavorite');
// // Event click
// if (favoriteBtn) {
//     !!favoriteBtn && favoriteBtn.addEventListener('click', function() {
//         favoriteBtn.closest('.header').querySelector('.tools-view #divFavorites').classList.toggle('show-list');
//     })
// }


// =======================================================
// Quick Access
// =======================================================
// Variable
const accessBtn = document.querySelector('.quick-access__title');

// Event click
if (accessBtn) {
    !!accessBtn && accessBtn.addEventListener('click', function() {
        accessBtn.closest('.quick-access').classList.toggle('open');
    })
}
